<script setup>
  defineProps({
    size: {
      type: [String, Number],
      default: 24
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 24 24'
    }
  })
</script>

<template>
  <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       width="48" height="48">
    <path d="M992 0H0v256h128V128h320v768H256v128h512v-128H576V128h320v128h128V0z"></path>
  </svg>
</template>

<style scoped>

</style>